import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=377002dc&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&lang=ts"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=377002dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377002dc",
  null
  
)

export default component.exports